export const ProductPhotoPicker = () => ({
  currentImageIndex: 0,
  totalImages: 0,
  isAdultProduct: false,
  isImageRevealed: false,

  init() {
    this.initializeTotalImages()
    this.updateMainPhoto()

    this.isAdultProduct = this.$el.dataset.isAdult === 'true'

    this.$watch("currentImageIndex", () => {
      this.updateMainPhoto()
      this.isImageRevealed = false
    })

    this.$el.addEventListener("keydown", (event) => {
      if (event.key === "ArrowLeft") {
        event.preventDefault()
        this.previousPhoto()
      } else if (event.key === "ArrowRight") {
        event.preventDefault()
        this.nextPhoto()
      }
    })

    this.$el.setAttribute("tabindex", "0")
  },

  initializeTotalImages() {
    const imageElements = document.querySelectorAll("[data-product-image-id]")
    this.totalImages = imageElements.length
  },

  updateMainPhoto() {
    const currentThumbnail = document.querySelector(`[data-image-index="${this.currentImageIndex}"]`)
    if (currentThumbnail && this.$refs.mainPhoto) {
      const imgElement = currentThumbnail.querySelector("img")
      if (imgElement?.dataset.largeSrc) {
        this.$refs.mainPhoto.src = imgElement.dataset.largeSrc
      }
    }
  },

  pickPhoto(index) {
    const targetIndex = parseInt(index)

    if (targetIndex >= 0 && targetIndex < this.totalImages) {
      this.currentImageIndex = targetIndex
    }
  },

  scrollToCurrentThumbnail() {
    const thumbnailContainer = document.querySelector("[data-thumbnail-container]")
    const currentThumbnail = document.querySelector(`[data-image-index="${this.currentImageIndex}"]`)

    if (thumbnailContainer && currentThumbnail) {
      const thumbnailLeft = currentThumbnail.offsetLeft
      const thumbnailWidth = currentThumbnail.offsetWidth
      const containerWidth = thumbnailContainer.offsetWidth
      const targetScrollLeft = thumbnailLeft - containerWidth / 2 + thumbnailWidth / 2

      thumbnailContainer.scrollTo({
        left: targetScrollLeft,
        behavior: "smooth",
      })
    }
  },

  previousPhoto() {
    if (this.totalImages === 0) return

    this.currentImageIndex = this.currentImageIndex > 0 ? this.currentImageIndex - 1 : this.totalImages - 1

    this.$nextTick(() => {
      this.scrollToCurrentThumbnail()
    })
  },

  nextPhoto() {
    if (this.totalImages === 0) return

    this.currentImageIndex = this.currentImageIndex < this.totalImages - 1 ? this.currentImageIndex + 1 : 0

    this.$nextTick(() => {
      this.scrollToCurrentThumbnail()
    })
  },

  handleVariantImageChange(event) {
    const { imageId } = event.detail

    if (!imageId) return

    const imageElement = document.querySelector(`[data-product-image-id="${imageId}"]`)

    if (imageElement) {
      const imageIndex = imageElement.getAttribute("data-image-index")
      if (imageIndex !== null) {
        this.currentImageIndex = parseInt(imageIndex)
        this.$nextTick(() => {
          this.scrollToCurrentThumbnail()
        })
      }
    }
  },

  handleMouseDown() {
    if (this.isAdultProduct) {
      this.isImageRevealed = true
    }
  },

  handleMouseUp() {
    if (this.isAdultProduct) {
      this.isImageRevealed = false
    }
  },

  handleMouseLeave() {
    if (this.isAdultProduct) {
      this.isImageRevealed = false
    }
  },

  handleTouchStart() {
    if (this.isAdultProduct) {
      this.isImageRevealed = true
    }
  },

  handleTouchEnd() {
    if (this.isAdultProduct) {
      this.isImageRevealed = false
    }
  },

  getMainImageClasses() {
    const baseClasses = 'w-full h-full object-cover rounded-2xl transition-all duration-300 select-none'
    if (this.isAdultProduct && !this.isImageRevealed) {
      return `${baseClasses} blur-3xl`
    }
    return baseClasses
  },

  getThumbnailImageClasses() {
    const baseClasses = 'w-full h-full object-cover transition-all duration-300 select-none'
    if (this.isAdultProduct && !this.isImageRevealed) {
      return `${baseClasses} blur-sm`
    }
    return baseClasses
  },
})
